module.exports = __webpack_public_path__ + "img/mockup-2.b09b3f5f.png";